import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Ambulance, LogOut } from "lucide-react";

// Mobile-first page shown to drivers whose agency's RideWise subscription is
// locked (trial ended / canceled / past due). The driver portal does not use
// the agency Layout, so this mirrors DriverAccount.jsx's own header shell.
export default function DriverSubscriptionEnded() {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-[#0A192F] text-white">
        <div className="max-w-lg mx-auto px-5 py-4 flex items-center gap-2.5">
          <div className="w-9 h-9 rounded-md bg-[#005E82] flex items-center justify-center">
            <Ambulance size={18} />
          </div>
          <div>
            <div className="font-display font-semibold text-sm">RideWise NEMT</div>
            <div className="text-[11px] text-slate-400 truncate max-w-[180px]">{user?.email}</div>
          </div>
        </div>
      </header>

      <div className="max-w-lg mx-auto px-4 pt-10 pb-24" data-testid="driver-subscription-ended">
        <div className="bg-white border border-slate-200 rounded-md p-6 text-center">
          <p className="text-sm text-slate-700">
            Your company's RideWise subscription is not active. Please contact your dispatcher.
          </p>
          <button
            onClick={logout}
            className="mt-5 w-full flex items-center justify-center gap-2 text-sm px-3 py-2.5 rounded-md border border-slate-200 hover:border-slate-400"
            data-testid="driver-subscription-ended-signout"
          >
            <LogOut size={14} /> Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
